export default [
  {
    path: '/manual-top-up',
    name: 'list-manual-top-up',
    component: () => import('@/views/manualTopUp/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.manualTopUp',
      resource: 'manual-top-up',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.manualTopUp',
          active: true,
        },
      ],
    },
  },
]
